import io from 'socket.io-client';
import { config } from "../../services/config";

// conexion socket especifica para los asientos en tiempo real
export const asientosSocket = io(config.URL_SOCKET, {
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 10000,
    path: "/socket/",
    autoConnect: false,
});

let isConnected = false;
let currentEventoId = null;

export const conectarAsientos = () => {
    if (!isConnected) {
        asientosSocket.connect();
    }
};

export const desconectarAsientos = () => {
    if (isConnected && currentEventoId) {
        asientosSocket.emit('desuscribirse-evento', currentEventoId);
        currentEventoId = null;
    }
    if (isConnected) {
        asientosSocket.disconnect();
    }
};

export const suscribirseAEvento = (eventoId) => {
    if (!isConnected) {
        conectarAsientos();
    }
    
    // si ya estaba en otro evento, primero se desuscribe
    if (currentEventoId && currentEventoId !== eventoId) {
        asientosSocket.emit('desuscribirse-evento', currentEventoId);
    }
    
    currentEventoId = eventoId;
    asientosSocket.emit('suscribirse-evento', eventoId);
};

export const desuscribirseDeEvento = (eventoId) => {
    if (isConnected) {
        asientosSocket.emit('desuscribirse-evento', eventoId);
    }
    if (currentEventoId === eventoId) {
        currentEventoId = null;
    }
};

// escuchar las actualizaciones
export const onAsientoUpdate = (callback) => {
    asientosSocket.on('asiento-updated', callback);
};

// dejar de escuchar las actualizaciones
export const offAsientoUpdate = () => {
    asientosSocket.off('asiento-updated');
};

asientosSocket.on('connect', () => {
    isConnected = true;
    
    if (currentEventoId) {
        asientosSocket.emit('suscribirse-evento', currentEventoId);
    }
});

asientosSocket.on('disconnect', () => {
    isConnected = false;
});

asientosSocket.on('connect_error', (error) => {
    console.error('❌ Error conectando socket de asientos:', error);
});

export const isAsientosConnected = () => isConnected;

export const getCurrentEvento = () => currentEventoId;